import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import cn from 'classnames';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from 'prop-types';
import { IconButton } from '@material-ui/core';
import { colors } from '../../constants/styleConstants';

const useStyles = makeStyles(theme => ({
  paper: {
    position: 'absolute',
    width: '50vw',
    height: 'auto',
    backgroundColor: theme.palette.background.paper,
    border: 0,
    boxShadow: theme.shadows[5],
    padding: 0,
    top: '50%',
    left: '50%',
    transform: `translate(-50%, -50%)`,
    outline: 'none',
    [theme.breakpoints.down('sm')]: {
      width: '80vw',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    '&:focus': {
      outline: 'none',
    },
  },
  closeIcon: {
    position: 'absolute',
    padding: 0,
    zIndex: 2,
    top: '1px',
    right: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    background: colors.white,
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
      backgroundColor: colors.white,
    },
  },
  transparentClose: {
    background: 'none',
    cursor: 'pointer',
    '&:hover': {
      opacity: 1,
      backgroundColor: 'rgba(0, 0, 0, 0.2)',
    },
  },
}));

const SimpleModal = ({
  isModalOpen,
  onClose,
  children,
  className,
  hideCloseIcon,
  contentClassName,
  transparentClose,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <Modal
      open={isModalOpen}
      onClose={onClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      {...rest}
    >
      <div className={cn(classes.paper, className)}>
        {!hideCloseIcon && (
          <IconButton
            className={cn(classes.closeIcon, { [classes.transparentClose]: transparentClose })}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        )}
        <div className={contentClassName || classes.content}>{children}</div>
      </div>
    </Modal>
  );
};

SimpleModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  className: PropTypes.string,
  onClose: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  hideCloseIcon: PropTypes.bool,
};

export default SimpleModal;
